import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../../utils/breakpoint";
import getBorderColor from "../../../../utils/getBorderColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import Picture from "../../../quarks/Picture";
import AlignContentOrg from "../../AlignContentOrg";
import BreakpointVisibilityOrg from "../../BreakpointVisibilityOrg";
import FlexContainerOrg from "../../FlexContainerOrg";
import FlexItemOrg from "../../FlexItemOrg";
import GridOrg from "../../GridOrg";
var Row = styled.div.withConfig({
  componentId: "sc-1e6q68c-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;align-items:center;margin-bottom:", ";padding-top:", ";padding-bottom:", ";border-bottom:", " solid ", ";&:last-child{margin-bottom:0;border-bottom:none;}", "{align-items:flex-start;}"], space(1), space(2.5), space(2.5), unit(1), getBorderColor(theme, "background", "low"), breakpoint("small", "medium"));
});
var StyledAlignContentOrg = styled(AlignContentOrg).withConfig({
  componentId: "sc-1e6q68c-1"
})(["", "{align-items:flex-start;margin-bottom:", ";text-align:left;}"], breakpoint("small", "medium"), space(0.5));
var StyledBreakpointVisibilityOrg = styled(BreakpointVisibilityOrg).withConfig({
  componentId: "sc-1e6q68c-2"
})(["flex-shrink:0;margin-right:", ";"], space(2));
function RowMol(_ref2) {
  var row = _ref2.row;
  return /*#__PURE__*/React.createElement(Row, null, row.icon ? /*#__PURE__*/React.createElement(StyledBreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(Picture, {
    srcData: row.icon
  })) : null, /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 1
  }, /*#__PURE__*/React.createElement(GridOrg, {
    gutterSpace: 0,
    columns: {
      small: 1,
      medium: row.cells.length,
      large: row.cells.length
    }
  }, row.cells.map(function (cell, cellIndex) {
    return /*#__PURE__*/React.createElement(StyledAlignContentOrg
    /* eslint-disable react/no-array-index-key */, {
      key: "Cell-".concat(cellIndex),
      horizontalAlign: cell.align
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      alignItems: "center"
    }, row.icon ? /*#__PURE__*/React.createElement(StyledBreakpointVisibilityOrg, {
      from: "medium"
    }, cellIndex === 0 && /*#__PURE__*/React.createElement(Picture, {
      srcData: row.icon
    })) : null, /*#__PURE__*/React.createElement(FlexItemOrg, {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 1
    }, cell.text)));
  }))));
}
export default RowMol;